window.bundleDataF = {
"Felix-boy": {
displayName: "Felix",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Felix Personalized Coloring Experience",
variantId: "49343617564909",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Felix_final_cover.png?v=1771691710",
price: "$14.99",
preorder: true
},
{
title: "Felix Dragon Holographic Sticker",
variantId: "49933771440365",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Felix_holographic_sticker.png?v=1779648205",
price: "$4.99",
preorder: false
},
{
title: "Felix Calling Gift Sticker",
variantId: "49933463617773",
image: "https://lkbunting.com/cdn/shop/files/BD75B2EC-A7BE-4460-8B0C-3995A3F132D4.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Fernando-boy": {
displayName: "Fernando",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Fernando Personalized Coloring Experience",
variantId: "49343618351341",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Fernando_final_cover.png?v=1772469698",
price: "$14.99",
preorder: true
},
{
title: "Fernando Dragon Holographic Sticker",
variantId: "49933771407597",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Fernando_holographic_sticker.png?v=1779648214",
price: "$4.99",
preorder: false
},
{
title: "Fernando Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Finley-boy": {
displayName: "Finley",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Finley Personalized Coloring Experience",
variantId: "49274717339885",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Finley_final_cover.png?v=1772469696",
price: "$14.99",
preorder: true
},
{
title: "Finley Dragon Holographic Sticker",
variantId: "49933780451565",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Finley_holographic_sticker.png?v=1779648214",
price: "$4.99",
preorder: false
},
{
title: "Finley Calling Gift Sticker",
variantId: "49933465977069",
image: "https://lkbunting.com/cdn/shop/files/4838A05A-04A0-4B87-B29E-D1DD51D0D666.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Finn-boy": {
displayName: "Finn",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Finn Personalized Coloring Experience",
variantId: "49299073663213",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Finn_final_cover.png?v=1772753295",
price: "$14.99",
preorder: true
},
{
title: "Finn Dragon Holographic Sticker",
variantId: "49933772620013",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Finn_holographic_sticker.png?v=1779648210",
price: "$4.99",
preorder: false
},
{
title: "Finn Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Flora-girl": {
displayName: "Flora",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Flora Personalized Coloring Experience",
variantId: "49801336094957",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Flora_final_cover.png?v=1775415417",
price: "$14.99",
preorder: true
},
{
title: "Flora Unicorn Holographic Sticker",
variantId: "49933746209005",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Flora_holographic_sticker.png?v=1779425515",
price: "$4.99",
preorder: false
},
{
title: "Flora Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Florence-girl": {
displayName: "Florence",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Florence Personalized Coloring Experience",
variantId: "49508294197485",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Florence_final_cover.png?v=1773105079",
price: "$14.99",
preorder: true
},
{
title: "Florence Unicorn Holographic Sticker",
variantId: "49933758136557",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Florence_holographic_sticker.png?v=1779425516",
price: "$4.99",
preorder: false
},
{
title: "Florence Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Francisco-boy": {
displayName: "Francisco",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Francisco Personalized Coloring Experience",
variantId: "49343621005549",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Francisco_final_cover.png?v=1772469698",
price: "$14.99",
preorder: true
},
{
title: "Francisco Dragon Holographic Sticker",
variantId: "49933771374829",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Francisco_holographic_sticker.png?v=1779648212",
price: "$4.99",
preorder: false
},
{
title: "Francisco Calling Gift Sticker",
variantId: "49933465977069",
image: "https://lkbunting.com/cdn/shop/files/4838A05A-04A0-4B87-B29E-D1DD51D0D666.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Freya-girl": {
displayName: "Freya",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Freya Personalized Coloring Experience",
variantId: "49508360782061",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Freya_final_cover.png?v=1773105080",
price: "$14.99",
preorder: true
},
{
title: "Freya Unicorn Holographic Sticker",
variantId: "49933757808877",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Freya_holographic_sticker.png?v=1779489479",
price: "$4.99",
preorder: false
},
{
title: "Freya Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Faith-girl": {
displayName: "Faith",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Faith Personalized Coloring Experience",
variantId: "50274181251309",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Faith_final_cover.png?v=1783795016",
price: "$14.99",
preorder: true
},
{
title: "Faith Unicorn Holographic Sticker",
variantId: "50274697838829",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Faithholographicsticker.png?v=1783829168",
price: "$4.99",
preorder: false
},
{
title: "Faith Calling Gift Sticker",
variantId: "49933476167917",
image: "https://lkbunting.com/cdn/shop/files/A7B9C9D3-6947-4D40-92ED-A4BB6DA62635.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} 


};